import
  React, {
  useContext
}  from 'react';

import {
  useHistory
} from 'react-router-dom';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  JourneyProvider,
  Text,
  VContainerH,
  VContainerVH
} from '@vodacom/web-common';

import {
  PrimaryButton,
  SecondaryButton
} from 'components';

import {
  withScreenViewTagging
} from 'hocs';

import {
  AppContext
} from 'context';

import {
  handleUtagLinkEvent,
  isFeatureEnabled,
  useRedirectHandler
} from 'helpers';

import {
  AAPromptStates,
  CustomColors,
  FeatureToggles
} from '../../constants';

import {
  Modal
} from '../modal';

const Card = styled(VContainerH)`
  z-index: 5;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const AirtimeAdvancePromptUI = props => {

  const {
    setPromptState,
    config
  } = useContext(AppContext);
  const history = useHistory();
  const redirectHandler = useRedirectHandler();

  AirtimeAdvancePromptUI.tagViewData = props.tagViewData;
  AirtimeAdvancePromptUI.pageName = props.pageName;

  return (

    <>

      { props.renderModal &&
        <Modal/>
      }

      <Card
        backgroundColor={CustomColors.White}
        borderRadius={'4px'}
        padding={'24px 16px'}
        maxWidth={'350px'}
        boxSizing={'border-box'}
        width={'92%'}>

        <VContainerVH
          padding={'0 24px'}>

          <Text
            fontSize={'16px'}
            fontWeight={'bold'}
            color={CustomColors.Grey9}
            textAlign={'center'}
            padding={'0 0 16px'}>

            {props.headerText}

          </Text>

          <Text
            fontSize={'14px'}
            color={CustomColors.Grey9}
            textAlign={'center'}
            padding={'0 0 24px'}>

            {props.bodyText}

          </Text>

        </VContainerVH>

        <PrimaryButton
          margin={'0 0 16px'}
          text={'Get an advance'}
          onClick={() => {

            handleUtagLinkEvent({
              event_name: 'campaign_internal_click',
              link_id: 'cbu: connectu: airtime advance: get information screen: proceed'
            });

            if (!isFeatureEnabled(config, FeatureToggles.EnableAirtimeAdvance)) {

              redirectHandler(
                history.location,
                '/redirect?targetUrl=https://www.vodacom.co.za/vodacom/services/airtime-advance&isZeroRated=true',
                true
              );

              return;
            }

            setPromptState(AAPromptStates.Started);

            history.push('/advance');

          }}/>

        <SecondaryButton
          text={'No thanks, I’ll carry on'}
          margin={'0 0 32px'}
          onClick={() => {

            handleUtagLinkEvent({
              event_name: 'campaign_internal_click',
              link_id: 'cbu: connectu: airtime advance: get information screen: close'
            });

            props.onClose?.();
          }}/>

        <Text
          fontSize={'16px'}
          fontWeight={'bold'}
          lineHeight={'24px'}
          textDecoration={'underline'}
          textAlign={'center'}
          color={CustomColors.Grey9}
          onClick={() => {

            JourneyProvider.set('Prompt', { url: '' });
            JourneyProvider.set('Prompt', { returnUrl: '' });

            history.push('/home');
          }} >

          {'Return to connectU homepage'}
        </Text>

      </Card>
    </>
  );
};

AirtimeAdvancePromptUI.propTypes = {
  onClose: PropTypes.func,
  pageName: PropTypes.string,
  tagViewData: PropTypes.object,
  renderModal: PropTypes.bool
};

AirtimeAdvancePromptUI.defaultProps = {
  onClose: () => {},
  pageName: '',
  tagViewData: {},
  renderModal: false,
  headerText: 'You’re about to run out of data',
  bodyText: 'To continue browsing, check if you qualify for a Data Advance and pay the next time you recharge.'
};

export const AirtimeAdvancePrompt = withScreenViewTagging(AirtimeAdvancePromptUI);
